/* eslint-disable radix */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-nested-ternary */
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import useMessageDispatcher from 'hooks/useMessageDispatcher';
import {
    Box,
    Chip,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography
} from '@mui/material';
import { FieldArray } from 'formik';

const header = {
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
        'Content-Type': 'application/json'
    }
};
const headerStyle = {
    textAlign: 'center',
    color: '#005e9f',
    fontWeight: 600,
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    zIndex: 1
};
const textBoxStyle = { width: '80px' };
const cellStyle = { textAlign: 'center' };

const SemesterStudentList = ({ values, setFieldValue, setIsLoading, handleSearch }) => {
    const filteredSubject = values?.courseList?.find((item) => item?.id === values?.selectedSubjectDetail);
    const internalAssessments = values?.internalAssessments;
    const [totalIaMarks, settotalIaMarks] = useState(0);
    const [totalofall, settotalofall] = useState(0);
    const [totalofmarks, settotalofmarks] = useState([]);
    const showMessage = useMessageDispatcher();
    const submitMarksHandler = async (marks, index, studentId, type) => {
        const { studentExamRecord } = values.semesterStudentData[index];
        const { descriptiveMarks, objectiveMarks, practicalMarks } = studentExamRecord;
        const iaMarks = isNaN(values.semesterStudentData[index]?.marks[values.semesterStudentData[index].marks?.length - 1])
            ? 0
            : values.semesterStudentData[index]?.marks[values.semesterStudentData[index].marks?.length - 1];

        const descriptive = type === 'descriptive' ? marks : isNaN(descriptiveMarks) ? 0 : descriptiveMarks;
        const objective = type === 'objective' ? marks : isNaN(objectiveMarks) ? 0 : objectiveMarks;
        const practical = type === 'practical' ? marks : isNaN(practicalMarks) ? 0 : practicalMarks;
        const marksScored = Number(descriptive) + Number(objective) + Number(practical);
        // const marksScored = Number(descriptive) + Number(objective) + Number(practical) + Number(iaMarks);
        const theoryMark = objective + descriptive;
        const theory = type === 'theory' ? marks : isNaN(theoryMark) ? 0 : theoryMark;
        const shallowTotalMarksArray = totalofmarks;
        shallowTotalMarksArray[index] = theoryMark;
        settotalofmarks([]);
        settotalofmarks(shallowTotalMarksArray);
        const shallowStudentExamRecord = values.semesterStudentData[index].studentExamRecord;
        shallowStudentExamRecord.descriptiveMarks = descriptive;
        shallowStudentExamRecord.objectiveMarks = objective;
        shallowStudentExamRecord.practicalMarks = practical;
        shallowStudentExamRecord.theoryMarks = theory;

        const shallowSemesterStudentData = values.semesterStudentData;
        shallowSemesterStudentData[index].studentExamRecord = shallowStudentExamRecord;

        try {
            const response = await axios.post(
                `/v1/exams/marks/entry?subjectDetailId=${values?.selectedSubjectDetail}&examGroupId=${
                    values?.examId
                }&studentId=${studentId}&marksScored=${marksScored}&descriptiveMarks=${descriptive}&objectiveMarks=${objective}&theoryMarks=${
                    filteredSubject?.subjectMini?.lab ? 0 : theory
                }&practicalMarks=${filteredSubject?.subjectMini?.theory ? 0 : practical}`,
                {},
                header
            );
            if (response.status === 200) {
                setFieldValue('semesterStudentData', shallowSemesterStudentData);
                showMessage({ message: response?.data?.Msg, color: 'success' });
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const safeSum = (arr) => arr.reduce((sum, val) => sum + (isNaN(parseFloat(val)) ? 0 : parseFloat(val)), 0);
    const handleAttendance = async (id) => {
        try {
            const response = await axios.put(`/v1/exams/mark-attendance?studentExamRecordId=${id}`, {}, header);
            if (response.status === 200) {
                if (response.data.code !== '403') {
                    // handleSearch();
                    showMessage({ message: response?.data?.data, color: 'success' });
                }
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.data, color: 'error' });
            }
        }
    };
    useEffect(() => {
        const totalMarksArray = Array(values?.semesterStudentData?.length).fill(0);
        values?.semesterStudentData?.forEach((row, index) => {
            const objectiveMarksValue = parseFloat(row?.studentExamRecord?.objectiveMarks) || 0;
            const descriptiveMarksValue = parseFloat(row?.studentExamRecord?.descriptiveMarks) || 0;
            settotalofall(
                safeSum([
                    values?.semesterStudentData?.[values?.semesterStudentData?.length - 1]?.total,
                    filteredSubject?.subjectMini?.theoryMarks,
                    filteredSubject?.subjectMini?.practicalMarks
                ])
            );

            totalMarksArray[index] = objectiveMarksValue + descriptiveMarksValue;
        });

        settotalofmarks(totalMarksArray);
    }, [values?.semesterStudentData, filteredSubject]);
    return (
        <TableContainer component={Paper}>
            <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>
                <span style={{ fontWeight: 'bold' }}>Total Marks : </span>
                {/* <span>{totalofall}</span> */}
                <span>{filteredSubject?.subjectMini?.totalMarks}</span>
            </Typography>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell style={headerStyle}>Sl.No.</TableCell>
                        <TableCell style={headerStyle}>Student Details</TableCell>
                        <TableCell style={headerStyle}>Attendance</TableCell>
                        {internalAssessments?.map((assessment, index) => (
                            <TableCell key={index} style={headerStyle}>
                                {assessment}({index === internalAssessments.length - 1 ? 'Out of:' : 'Max:'}
                                {values.semesterStudentData[0].total[index]})
                            </TableCell>
                        ))}
                        {filteredSubject?.subjectMarks !== null && (
                            <>
                                <TableCell style={headerStyle}>
                                    Objective Marks (Max:{filteredSubject?.subjectMarks?.objectiveMarks})
                                </TableCell>
                                <TableCell style={headerStyle}>
                                    Descriptive Marks (Max:{filteredSubject?.subjectMarks?.subjectiveMarks})
                                </TableCell>
                            </>
                        )}
                        {filteredSubject?.subjectMini ? (
                            filteredSubject?.subjectMini?.labAndTheory ? (
                                <>
                                    <TableCell style={headerStyle}>
                                        Theory Marks (Max:{filteredSubject?.subjectMini?.theoryMarks})
                                    </TableCell>
                                    {filteredSubject?.subjectMini?.practicalMarks > 0 && (
                                        <TableCell style={headerStyle}>
                                            Practical Marks (Max:{filteredSubject?.subjectMini?.practicalMarks})
                                        </TableCell>
                                    )}
                                </>
                            ) : filteredSubject?.subjectMini?.lab ? (
                                <>
                                    {filteredSubject?.subjectMini?.practicalMarks > 0 && (
                                        <TableCell style={headerStyle}>
                                            Practical Marks (Max:{filteredSubject?.subjectMini?.practicalMarks})
                                        </TableCell>
                                    )}
                                </>
                            ) : (
                                <TableCell style={headerStyle}>Theory Marks (Max:{filteredSubject?.subjectMini?.theoryMarks})</TableCell>
                            )
                        ) : null}

                        <TableCell style={headerStyle}>Total Obtained Marks</TableCell>
                    </TableRow>
                </TableHead>
                <FieldArray
                    name="semesterStudentData"
                    render={() => (
                        <TableBody>
                            {values?.semesterStudentData?.length > 0 &&
                                values?.semesterStudentData
                                    ?.sort((a, b) => {
                                        const courseA = a?.studentExamRecord?.studentMini.rollNo?.split('/')[1];
                                        const courseB = b?.studentExamRecord?.studentMini.rollNo?.split('/')[1];

                                        if (courseA < courseB) return -1;
                                        if (courseA > courseB) return 1;

                                        const rollNoA = a?.studentExamRecord?.studentMini.rollNo?.split('/')[2];
                                        const rollNoB = b?.studentExamRecord?.studentMini.rollNo?.split('/')[2];
                                        return parseInt(rollNoA) - parseInt(rollNoB);
                                    })
                                    ?.map((row, index) => (
                                        <TableRow key={row?.index}>
                                            <TableCell style={cellStyle} component="th">
                                                {index + 1}
                                            </TableCell>
                                            <TableCell>
                                                <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                    <Chip
                                                        label={row?.studentExamRecord?.attendedExam ? 'P' : 'A'}
                                                        size="small"
                                                        sx={{
                                                            color: 'black',
                                                            background: row?.studentExamRecord?.attendedExam ? '#00c853' : '#ff1744',
                                                            borderRadius: '50%',
                                                            marginRight: '8px'
                                                        }}
                                                        variant="outlined"
                                                    />
                                                    <Box>
                                                        <Typography
                                                            style={{
                                                                fontWeight: 500,
                                                                fontSize: '15px',
                                                                color: '#333'
                                                            }}
                                                        >
                                                            {row?.studentExamRecord?.studentMini?.studentName}
                                                        </Typography>
                                                        <Typography
                                                            variant="h6"
                                                            style={{
                                                                fontWeight: 600,
                                                                fontSize: '13px',
                                                                color: '#757575'
                                                            }}
                                                        >
                                                            {row?.studentExamRecord?.studentMini?.rollNo}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </TableCell>
                                            <TableCell style={cellStyle} component="th">
                                                <Switch
                                                    defaultChecked={row?.studentExamRecord?.attendedExam}
                                                    onChange={(event) => {
                                                        handleAttendance(row?.studentExamRecord?.id);
                                                    }}
                                                />
                                            </TableCell>
                                            {row?.marks?.map((mark, index) => (
                                                <TableCell key={index} style={cellStyle}>
                                                    {isNaN(parseFloat(mark)) ? 0 : Math.round(mark)}
                                                </TableCell>
                                            ))}

                                            {filteredSubject?.subjectMarks !== null && (
                                                <>
                                                    <TableCell style={cellStyle}>
                                                        <TextField
                                                            onFocus={(e) => e.target.select()}
                                                            style={textBoxStyle}
                                                            name={`semesterStudentData.${index}.objectiveMarks`}
                                                            value={
                                                                values.semesterStudentData[index]?.studentExamRecord?.objectiveMarks || 0
                                                            }
                                                            onChange={(event) => {
                                                                const { value } = event.target;
                                                                const maxMarks = filteredSubject?.subjectMarks?.objectiveMarks || 0;
                                                                if (!/^\d*$/.test(value)) return;
                                                                const numericValue = value === '' ? '' : parseInt(value, 10);
                                                                if (numericValue !== '' && numericValue <= maxMarks) {
                                                                    setFieldValue(
                                                                        `semesterStudentData.${index}.objectiveMarks`,
                                                                        numericValue
                                                                    );

                                                                    const { studentId } =
                                                                        values.semesterStudentData[index]?.studentExamRecord;
                                                                    submitMarksHandler(numericValue, index, studentId, 'objective');
                                                                }
                                                            }}
                                                            disabled={!row?.studentExamRecord?.attendedExam}
                                                        />
                                                    </TableCell>
                                                    <TableCell style={cellStyle}>
                                                        <TextField
                                                            onFocus={(e) => e.target.select()}
                                                            style={textBoxStyle}
                                                            name={`semesterStudentData.${index}.descriptiveMarks`}
                                                            value={
                                                                values.semesterStudentData[index]?.studentExamRecord?.descriptiveMarks || 0
                                                            }
                                                            onChange={(event) => {
                                                                const { value } = event.target;
                                                                const maxMarks = filteredSubject?.subjectMarks?.subjectiveMarks || 0;
                                                                if (!/^\d*$/.test(value)) return;
                                                                const numericValue = value === '' ? '' : parseInt(value, 10);
                                                                if (numericValue !== '' && numericValue <= maxMarks) {
                                                                    setFieldValue(
                                                                        `semesterStudentData.${index}.descriptiveMarks`,
                                                                        numericValue
                                                                    );

                                                                    const { studentId } =
                                                                        values.semesterStudentData[index]?.studentExamRecord;
                                                                    submitMarksHandler(numericValue, index, studentId, 'descriptive');
                                                                }
                                                            }}
                                                            disabled={!row?.studentExamRecord?.attendedExam}
                                                        />
                                                    </TableCell>
                                                </>
                                            )}

                                            {filteredSubject?.subjectMini ? (
                                                filteredSubject?.subjectMini?.labAndTheory ? (
                                                    <>
                                                        <TableCell style={cellStyle}>
                                                            <TextField
                                                                onFocus={(e) => e.target.select()}
                                                                style={textBoxStyle}
                                                                name={`semesterStudentData.${index}.theory`}
                                                                disabled
                                                                value={Math.round(totalofmarks[index]) || 0}
                                                                onChange={(event) => {
                                                                    const { value } = event.target;
                                                                    const { studentId } =
                                                                        values.semesterStudentData[index]?.studentExamRecord;
                                                                    submitMarksHandler(value, index, studentId, 'theory');
                                                                }}
                                                            />
                                                        </TableCell>

                                                        {filteredSubject?.subjectMini?.practicalMarks > 0 && (
                                                            <TableCell style={cellStyle}>
                                                                <TextField
                                                                    onFocus={(e) => e.target.select()}
                                                                    style={textBoxStyle}
                                                                    name={`semesterStudentData.${index}.practical`}
                                                                    value={
                                                                        values.semesterStudentData[index]?.studentExamRecord
                                                                            ?.practicalMarks || 0
                                                                    }
                                                                    onChange={(event) => {
                                                                        const maxMarks = filteredSubject?.subjectMini?.practicalMarks || 0;
                                                                        const { value } = event.target;
                                                                        if (/^\d*$/.test(value) && Number(value) <= maxMarks) {
                                                                            setFieldValue(`semesterStudentData.${index}.practical`, value);
                                                                            const { studentId } =
                                                                                values.semesterStudentData[index]?.studentExamRecord;
                                                                            submitMarksHandler(value, index, studentId, 'practical');
                                                                        }
                                                                    }}
                                                                    disabled={!row?.studentExamRecord?.attendedExam}
                                                                />
                                                            </TableCell>
                                                        )}
                                                    </>
                                                ) : filteredSubject?.subjectMini?.lab ? (
                                                    <>
                                                        {filteredSubject?.subjectMini?.practicalMarks > 0 && (
                                                            <TableCell style={cellStyle}>
                                                                <TextField
                                                                    onFocus={(e) => e.target.select()}
                                                                    style={textBoxStyle}
                                                                    name={`semesterStudentData.${index}.practical`}
                                                                    value={
                                                                        !row?.studentExamRecord?.attendedExam
                                                                            ? 'AB'
                                                                            : values.semesterStudentData[index]?.studentExamRecord
                                                                                  ?.practicalMarks || 0
                                                                    }
                                                                    onChange={(event) => {
                                                                        const maxMarks = filteredSubject?.subjectMini?.practicalMarks || 0;
                                                                        const { value } = event.target;
                                                                        if (/^\d*$/.test(value) && Number(value) <= maxMarks) {
                                                                            setFieldValue(`semesterStudentData.${index}.practical`, value);
                                                                            const { studentId } =
                                                                                values.semesterStudentData[index]?.studentExamRecord;
                                                                            submitMarksHandler(value, index, studentId, 'practical');
                                                                        }
                                                                    }}
                                                                    disabled={!row?.studentExamRecord?.attendedExam}
                                                                />
                                                            </TableCell>
                                                        )}
                                                    </>
                                                ) : (
                                                    <>
                                                        <TableCell style={cellStyle}>
                                                            {' '}
                                                            <TextField
                                                                onFocus={(e) => e.target.select()}
                                                                style={textBoxStyle}
                                                                name={`semesterStudentData.${index}.theory`}
                                                                disabled
                                                                value={Math.round(totalofmarks[index]) || 0}
                                                                onChange={(event) => {
                                                                    const { value } = event.target;
                                                                    const { studentId } =
                                                                        values.semesterStudentData[index]?.studentExamRecord;
                                                                    submitMarksHandler(value, index, studentId, 'theory');
                                                                }}
                                                            />
                                                        </TableCell>
                                                    </>
                                                )
                                            ) : null}
                                            <TableCell style={cellStyle}>
                                                {Math.round(
                                                    safeSum(row?.marks || []) +
                                                        safeSum([
                                                            // row?.marks[index],
                                                            totalofmarks[index],
                                                            values?.semesterStudentData?.[index]?.studentExamRecord?.practicalMarks
                                                        ])
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                        </TableBody>
                    )}
                />
            </Table>
        </TableContainer>
    );
};

export default SemesterStudentList;
